import { Component, OnInit, ViewChild } from "@angular/core";
import mockedAixmCatalogue from "../mocked-aixm-catalogue.json";
import { ActivatedRoute } from "@angular/router";
import { MatTree, MatTreeFlattener } from "@angular/material/tree";
import { FlatTreeControl, NestedTreeControl } from "@angular/cdk/tree";
import { FeatureAccessRightsComponent } from "../dialogs/feature-access-rights/feature-access-rights.component";
import { MatDialog } from "@angular/material/dialog";
import { FeatureBusinessRuleComponent } from "../dialogs/feature-business-rule/feature-business-rule.component";
import { features } from "process";

interface TreeNode {
  name: string;
  children?: TreeNode[];
}

@Component({
  selector: "feature-view",
  templateUrl: "./feature-view.component.html",
  styleUrls: ["./feature-view.component.css"],
})
export class FeatureViewComponent implements OnInit {
  id: string | null = null;
  matchingFeature: any;
  metadataExpanded: boolean = false;
  @ViewChild(MatTree) tree: MatTree<TreeNode>;
  treeData: any = [];
  treeControl = new NestedTreeControl<TreeNode>((node) => node.children);
  propertyName: string;
  propertyGroupName: string;
  constructor(private route: ActivatedRoute, private dialog: MatDialog) {}

  openLockDialog() {
    const dialogRef = this.dialog.open(FeatureAccessRightsComponent, {
      width: "1000px",
      data: {
        feature: this.matchingFeature._name,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("Dijalog zatvoren, rezultat:", result);
    });
  }

  openBusinessRuleDialog() {
    const dialogRef = this.dialog.open(FeatureBusinessRuleComponent, {
      width: "1000px",
      height: "600px",

      data: {
        feature: this.matchingFeature._name,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("Dijalog zatvoren, rezultat:", result);
    });
  }
  findMatchingFeature(): void {
    if (this.id !== null) {
      const match = mockedAixmCatalogue?.schema?.element?.find(
        (el) => el?._name === this.id
      );
      if (match !== null) {
        this.matchingFeature = match;
        this.mapTreeData();
      }
    }
  }

  mapTreeData(): void {
    // const matchingPropertyGroup = mockedAixmCatalogue?.schema?.group?.find((el) => el?._name === (this.id + 'PropertyGroup'));
    // console.log('MATCHING PG: ', matchingPropertyGroup);
    // const mappedTreeData = [];
    //
    // if (matchingPropertyGroup) {
    //     const pgChildren = [];
    //     // @ts-ignore
    //     matchingPropertyGroup?.sequence?.element?.forEach((el) => {
    //         pgChildren.push({ name: el?._name });
    //     });
    //     console.log('PGCHILDREN: ', pgChildren);
    //     mappedTreeData.push({
    //         name: '<b>Group:</b> ' + matchingPropertyGroup?._name,
    //         children: pgChildren
    //     });
    // }
    // this.treeData = mappedTreeData;

    // http://localhost:4200/#/data-catalogue/feature/AerialRefuelling
    this.treeData = [
      {
        name: `<a href="/#/data-catalogue/feature/${this.id}/property-group/${this.matchingFeature?._name}TimeSliceType"><b>Group: </b>${this.matchingFeature?._name}TimeSliceType</a>`,
        children: [
          {
            //name: '<a href={"/#/data-catalogue/feature/" + this.id + "/property-group/" + this.matchingFeature?._name + "PropertyGroup"}><b>Group:</b> ' + this.matchingFeature?._name + 'PropertyGroup' + '</a>',
            name: `<a href="/#/data-catalogue/feature/${this.id}/property-group/${this.matchingFeature?._name}PropertyGroup"><b>Group: </b>${this.matchingFeature?._name}PropertyGroup</a>`,
            children: [
              {
                name: `<a href="/#/data-catalogue/feature/${this.id}/${this.matchingFeature?._name}PropertyGroup/designator">designator</a>`,
              },
              {
                name: `<a href="/#/data-catalogue/feature/${this.id}/${this.matchingFeature?._name}PropertyGroup/type">type</a>`,
              },
              {
                name: `<a href="/#/data-catalogue/feature/${this.id}/${this.matchingFeature?._name}PropertyGroup/name">name</a>`,
              },
              {
                name: `<a href="/#/data-catalogue/feature/${this.id}/${this.matchingFeature?._name}PropertyGroup/location">location</a>`,
                children: [
                  {
                    name: `<a href="/#/data-catalogue/feature/${this.id}/property-group/PointType"><b>Group: </b> PointType</a>`,
                    children: [
                      {
                        name: `<a href="/#/data-catalogue/feature/${this.id}/PointType/gml:pos">gml:pos</a>`,
                      },
                      {
                        name: `<a href="/#/data-catalogue/feature/${this.id}/property-group/PointPropertyGroup"><b>Group: </b> PointPropertyGroup</a>`,
                        children: [
                          {
                            name: `<a href="/#/data-catalogue/feature/${this.id}/PointPropertyGroup/horizontalAccuracy">horizontalAccuracy</a>`,
                          },
                          {
                            name: `<a href="/#/data-catalogue/feature/${this.id}/PointPropertyGroup/annotation">annotation</a>`,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ];
  }

  ngAfterViewInit() {
    this.expandAllNodes(this.treeData);
  }

  expandAllNodes(nodes: any[]) {
    if (!nodes) return;
    for (const node of nodes) {
      if (node.children && node.children.length > 0) {
        console.log("NODE: ", node);
        this.tree.treeControl.expand(node);
        this.expandAllNodes(node.children); // Recursively expand children
      }
    }
  }

  childrenAccessor = (node: any) => node.children;
  hasChild = (_: number, node: any) =>
    !!node.children && node.children.length > 0;

  toggleMetadata(): void {
    this.metadataExpanded = !this.metadataExpanded;
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get("id");

    this.route.paramMap.subscribe((params) => {
      this.id = params.get("id");
    });

    this.findMatchingFeature();
    if (!this.matchingFeature.displayName) {
      this.matchingFeature.displayName = this.matchingFeature._name;
    }
    if (!this.matchingFeature.description) {
      this.matchingFeature.description = "description"; 
    }
  }

  save(): void {
    console.log("Save icon clicked");
 
  }
}
